import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-efeasibility-widget',
	templateUrl: './efeasibility-widget.component.html',
	styleUrl: './efeasibility-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, TranslateModule, MatButtonModule, RouterLink, MatIconModule, LoadingSpinnerComponent]
})

export class EFeasibilityWidgetComponent {
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	isLoading = false;
}
